import React, { useState, useEffect } from 'react'
import Button, { TYPES } from '../Button/index'

const COMPLETE = 100

function getClassName (props, progress) {
  const { className, completionClassName } = props
  const baseClassName = 'button-progress'
  const classNameArray = [baseClassName]

  if (className) {
    classNameArray.push(className)
  }

  if (progress >= COMPLETE) {
    classNameArray.push(completionClassName)
  }

  return classNameArray.join(' ')
}

function ButtonProgress (props) {
  const {
    onMount = true,
    progressDurationMS = 5000,
    progressText = '',
    completionText = '',
    completionUrl = '',
    onClick = () => null,
  } = props
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    let interval = () => null

    if (onMount) {
      setProgress(0) // Reset progress
      const step = COMPLETE / (progressDurationMS / 100)

      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= COMPLETE) {
            clearInterval(interval)
            return COMPLETE
          }
          return prev + step
        })
      }, 100)
    }

    return () => clearInterval(interval) // Cleanup on unmount
  }, [])

  return (
    <Button
      className={getClassName(props, progress)}
      type={TYPES.SECONDARY}
      url={progress === COMPLETE ? completionUrl : null}
      onClick={onClick}
    >
      <span className="button-progress__text">
        {progress < COMPLETE
          ? progressText
          : completionText
        }
      </span>
      <span
        className="button-progress__progress"
        style={{ width: `${progress}%`, transition: 'width 0.1s linear' }}
      />
    </Button>
  )
}

export default ButtonProgress
